<template>
  <div>
    <div class="step-wrapper hidden sm:block">
      <Stepper
        v-model="stayNightsSP"
        min="1"
        max="6"
        style="min-width: 115px; max-width: 115px;"
        size="large"
        unit="泊"
        :disabled="disabled"
        />
    </div>

    <div class="block sm:hidden">
      <Modal :visible="visible" @ok="handleOk" @cancel="handleCancel">
        <a-card :bordered="false">
          <div class="input-title">宿泊日を指定</div>
          <div class="main-availability" ref="calendar">
            <div class="content__box">
              <div class="cal-days">

                <!-- 日付を選択するチェックボックス -->
                <div class="content__input">
                  <input type="checkbox" id="checkbox" v-model="isDateSpecified">
                  <label for="checkbox" class="content__label" @click="toggleCheckbox()">
                    日付を指定する
                  </label>
                </div>
              </div>
            </div>

            <!-- 宿泊数 -->
            <div class="content__box" :hidden="!isDateSpecified">
              <div class="stepper">宿泊数</div>
              <Stepper
                v-model="stayNights"
                min="1"
                max="6"
                style="width: 120px"
                size="large"
                unit=" 泊"
                @change="onNativeSearch"
              /> 
            </div>

            <!-- カレンダー -->
            <div class="form-book" :hidden="!isDateSpecified">
              <div class="calendar-wrap">
                <div class="cm-calendar">
                  <Calendar
                    :value="stayDay"
                    @input="onSelectDay"
                    :selectedDays="getSelectedDays"
                    :dayOpens="dayOpens"
                    :dayFewLefts="dayFewLefts"
                    :dayCloses="dayCloses"
                    :disabledDate="checkDisabledDate"
                    :disabledPrev="calendarDisabledPrev"
                    :rangeMode="true"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="sm-btn">
            <button @click="handleOk" class="c-btn btn-grey btn-cm">
              決定
            </button>
          </div>
        </a-card>
      </Modal>
    </div>    
  </div>
</template>

<script>
import { Modal, Stepper, Calendar } from '@/components/primitive'
import { DEFAULT_SEARCH_PLAN_RESULT } from '@/constants/default_search_plan_result'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'ChildrenAttach',
  components: {
    Modal,
    Calendar,
    Stepper
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filterForm: { // vacancy calendar で検索する為の基本クエリ
      type: Object,
      default() {
        return {}
      }
    },
    status: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stayDay: null,
      stayNights: 1,
      stayNightsSP: 1,
      isDateSpecified: false,

      fewLeftDayMap: {},
      outstockDayMap: {},
      instockDayMap: {},
      dateFormat: 'YYYY/MM/DD',
      vacancyCalendar: null,
      searchResult: null,
      dayOpens: null,
      dayFewLefts: null,
      dayCloses: null,
      total: 0
    }
  },

  created() {
    const { checkInDate, stayNights } = this.$route.query
    this.isDateSpecified = checkInDate && moment(checkInDate) ? true : false // checkInDate
    this.stayDay = ( checkInDate && moment(checkInDate) ) || moment().add(1, 'd')
    // クエリから数値を取得するときはNumberに変換する
    this.stayNights = Number(stayNights) || 1
    this.stayNightsSP = this.stayNights;
    this.getVacancyCalendar()
  },

  watch: {
    stayDay(val, old) {
      if (val && !val.isSame(old, 'month')) {
        this.$nextTick(() => {
          this.getVacancyCalendar()
        })
      }
    },

    stayNightsSP(val) {
      // SP用の入力欄から値を変更した場合のみ動作させる
      if (val != this.stayNights)
      {
        this.stayNights = val
        this.handleOk()
      }
    },
  },

  computed: {
    calendarDisabledPrev() {
      const now = moment(new Date())

      return this.stayDay ? this.stayDay.isSameOrBefore(now, 'month') : now.isSameOrAfter(now, 'month')
    },

    filterCloseDays() {
      const outstockDayMap = {}
      const lastDay = this.stayDay.clone().endOf('month').date()
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month =
          this.stayDay.month() + 1 > 9
            ? this.stayDay.month() + 1
            : `0${this.stayDay.month() + 1}`
        const day = `${this.stayDay.year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          outstockDayMap[day] = true
          closeDays.push(day)
        }
      }
      return closeDays
    },

    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = this.stayDay.format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },

    filterOpenDays() {
      const instockDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 4 || e.stock === 0)
      const instockDays = []
      vacancyCalendars.forEach((el) => {
        instockDayMap[el.stayDay] = true
        instockDays.push(el.stayDay)
      })
      return instockDays
    },

    filterFewLeftDays() {
      const fewLeftDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 0 && e.stock <= 4)
      const fewLeftDays = []
      vacancyCalendars.forEach((el) => {
        fewLeftDayMap[el.stayDay] = el.stock
        fewLeftDays.push(el.stayDay)
      })
      return fewLeftDays
    }
  },

  methods: {
    async getVacancyCalendar() {
      const { menuNo } = this.$route.params
        let checkInDate = null
        let checkOutDate = null
      if(this.stayDay) { 
        checkInDate = this.stayDay.clone().startOf('month').format('YYYY-MM-DD')
        checkOutDate = this.stayDay.clone().endOf('month').add(1, 'day').format('YYYY-MM-DD')
      } else {
        const stayDay = moment(new Date());
        checkInDate = stayDay.clone().startOf('month').format('YYYY-MM-DD')
        checkOutDate = stayDay.clone().endOf('month').add(1, 'day').format('YYYY-MM-DD')
      }
     
      const vacancyData = {
        checkInDate,
        checkOutDate,
        stayNights: this.stayNights         
      }

      this.vacancyCalendar = {
        vacancyCalendars: []
      }
      let data
      await this.$repositories('menu')
        .getSearchParamVacancyCalendar(menuNo, {
          ...this.filterForm,
          ...vacancyData
        })
        .then((response) => {
          data = response
          const dateAvailable = _.get(response, 'dateAvailableDetail', {})
          _.forEach(dateAvailable, (value, key) => {
            const stayDay = key.replace(/date_/g, '')
            const data = {
              stayDay: moment(stayDay).format(this.dateFormat),
              stock: value
            }
            this.vacancyCalendar.vacancyCalendars.push(data)
          })
        })
      const dateAvailable = _.get(data, 'dateAvailableDetail', {})
      const dateAvailableArr = Object.entries(dateAvailable)
      if (dateAvailableArr) {
        this.dayOpens = _.cloneDeep(dateAvailableArr)
          .filter((day) => {
            const dayTmpOpen = day[0].split('_')
            day[0] = moment(dayTmpOpen[1]).format('YYYY/MM/DD')
            return day[1] > 4 && moment(day[0]).diff(moment(), 'day') >= 0
          })
          .map((dayOpen) => {
            return dayOpen[0]
          })
        this.dayFewLefts = _.cloneDeep(dateAvailableArr)
          .filter((day) => {
            const dayTmpFew = day[0].split('_')
            day[0] = moment(dayTmpFew[1]).format('YYYY/MM/DD')
            return day[1] <= 4 && day[1] > 0 && moment(day[0]).diff(moment(), 'day') >= 0
          })
          .map((dayFew) => {
            return dayFew[0]
          })
        this.dayCloses = _.cloneDeep(dateAvailableArr)
          .filter((day) => {
            const dayTmpClose = day[0].split('_')
            day[0] = moment(dayTmpClose[1]).format('YYYY/MM/DD')
            return day[1] == 0 && moment(day[0]).diff(moment(), 'day') >= 0
          })
          .map((dayClose) => {
            return dayClose[0]
          })
      }
    },
    async onSelectDay($event) {
      // compare with today
      const today = moment(new Date())
      if ($event.isBefore(today, 'day')) {
        this.stayDay = today
      } else {
        this.stayDay = $event
      }
      await this.onNativeSearch()
    },
    checkDisabledDate($event) {
      const now = moment(new Date())
      return $event.isBefore(now, 'date')
    },
    dayOpenDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? _.cloneDeep(this.vacancyCalendar.vacancyCalendars)
          : []
      const instockDays = vacancyCalendars
        .filter((e) => e.stock > 4 || e.stock === 0)
        .map((el) => el.stayDay)

      if (this.status != null && this.status == 1) {
        return !$event.isBefore(now, 'day') &&
          instockDays.includes($event.format(this.dateFormat))
          ? vacancyCalendars
              .filter((e) => e.stayDay === $event.format(this.dateFormat))
              .map((el) => el.stock)
              .toString()
          : ''
      }

      return !$event.isBefore(now, 'date') &&
        instockDays.includes($event.format(this.dateFormat))
        ? '○'
        : ''
    },
    fewLeftDecorator($event) {
      const now = moment(new Date())
      // eslint-disable-next-line no-unused-vars
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => e.stock > 0 && e.stock <= 4 && e.stayDay === $event.format('YYYY/MM/DD')
      )

      if (this.status != null && this.status == 1) {
        return !$event.isBefore(now, 'day')
          ? vacancyCalendars
              .filter((e) => e.stayDay === $event.format(this.dateFormat))
              .map((el) => el.stock)
              .toString()
          : ''
      }

      return !$event.isBefore(now, 'date') ? '△' : ''
    },

    dayClosedDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []

      if (this.status != null && this.status == 1) {
        return !$event.isBefore(now, 'day') &&
          !inStockDays.includes($event.format(this.dateFormat))
          ? '0'
          : ''
      }

      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      return !$event.isBefore(now, 'date') &&
        !inStockDays.includes($event.format(this.dateFormat))
        ? '×'
        : ''
    },

    async onNativeSearch() {
      // 在庫のチェックを行い、宿泊日に在庫が無い日が存在する場合は、
      // 検索にヒットしなかった時の情報を検索結果として変数に格納する
      // 固定値なので、別ファイル定義
      const check = await this.checkAvailableApplyDays();
      if (!check) {
        this.searchResult = DEFAULT_SEARCH_PLAN_RESULT;
        return;
      }

      const { menuNo } = this.$route.params;
      const checkInDay = moment(this.stayDay);
      const checkOutDay = checkInDay.clone().add(this.stayNights, 'days');
      const checkTime = {
        checkInDate: checkInDay.format('YYYY-MM-DD'),
        checkOutDate: checkOutDay.format('YYYY-MM-DD')
      };
      this.$repositories('plan')
        .searchPlan(0, 10, menuNo, {
          ...this.filterForm,
          ...checkTime
        })
        .then((result) => {
          this.searchResult = result
          this.total = result.totalItems
        });
    },

    // 日毎在庫チェック用関数
    async checkAvailableApplyDays() {
      let availableApply = false;
      // 空室カレンダー情報を取得し、存在しない場合は空配列
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : [];
      // 算出プロパティから選択した宿泊日を取得
      const selectDays = _.cloneDeep(this.getSelectedDays);
      // チェックアウト日の在庫は考慮する必要が無いので削除する
      selectDays.pop();
      
      const today = moment();
      const checkInDay  = moment(selectDays[0]);
      const lastStayDay = moment(selectDays.slice(-1)[0]);
      
      // ↓ なぜか差分が取れない
      // diffMonth = lastStayDay.diff(checkInDay, 'months') > 0;

      // 当月の在庫データしかないので、月またぎをelse句で考慮する
      if (checkInDay.month() === lastStayDay.month() && checkInDay.month() === today.month()) {
        // 宿泊日に在庫が存在する日付を取得する => データなので中身はなんでも良い
        availableApply = this.checkStockAvailable(selectDays, vacancyCalendars);
      } else if (checkInDay.month() === lastStayDay.month() && checkInDay.month() !== today.month()) {
        // 日付が別月の、チェックイン日付～チェックアウト日付が当月内
        // 検索前在庫確認用にMNで翌月の在庫情報を取得する
        const nextMonthVacancyCalendars = await this.getVacamcyForDiffMonth(checkInDay);
        availableApply = this.checkStockAvailable(selectDays, nextMonthVacancyCalendars);
      } else {
        // 選択日付の最終要素から月初の日付を取得し、チェックイン日付とする
        const startDiffMonthDay = lastStayDay.clone().startOf('month');
        // 検索前在庫確認用にMNで翌月の在庫情報を取得する
        const nextMonthVacancyCalendars = await this.getVacamcyForDiffMonth(startDiffMonthDay);
        // 月またぎの際に各月の選択日付配列を作成する
        const startMonthSelectedDays = this.createSelectedDays("0", checkInDay);
        const nextMonthSelectedDays  = this.createSelectedDays("1", lastStayDay);
        availableApply = this.checkStockAvailable(startMonthSelectedDays, vacancyCalendars);
        availableApply = availableApply ? this.checkStockAvailable(nextMonthSelectedDays, nextMonthVacancyCalendars) : false;
      }

      return availableApply;
    },

    async getVacamcyForDiffMonth(stayDay) {
      const { menuNo }     = this.$route.params
      const checkInDate    = stayDay.clone().format('YYYY-MM-DD');
      const checkOutDate   = stayDay.clone().add(this.stayNights, 'day').format('YYYY-MM-DD');
      const stayNights     = this.stayNights
      let vacancyCalendars = [];
     
      const vacancyData = {
        checkInDate,
        checkOutDate,
        stayNights
      }

      await this.$repositories('menu')
        .getSearchParamVacancyCalendar(menuNo, {
          ...this.filterForm,
          ...vacancyData
        })
        .then((response) => {
          const dateAvailable = _.get(response, 'dateAvailableDetail', {});
          _.forEach(dateAvailable, (value, key) => {
            const stayDay = key.replace(/date_/g, '');
            const data = {
              stayDay: moment(stayDay).format(this.dateFormat),
              stock: value
            };
            vacancyCalendars.push(data);
          })
        });

      return vacancyCalendars;
    },

    checkStockAvailable(selectedDays, vacancyCalendars) {
      let available = false;
      const availableApplyDays = selectedDays.filter((day) => {
        const availableDays = vacancyCalendars.filter((e) => {
          return e.stock > 0 && e.stayDay === day;
        })
          return availableDays.length > 0;
      });
        
      // 在庫が存在する日付のみであるかのチェック
      if (availableApplyDays.length === selectedDays.length) {
        available = true;
      }

      return available;
    },

    // 月別に選択した日付を取得し、配列を生成する
    // 選択した日付の翌月かどうかで判定する
    // 選択できる最大宿泊日数が6日なので、2か月またぎは考慮しない
    createSelectedDays(funcType, selectDay) {
      let selectedDayByMonth = [];
      if(funcType === "0") {
        // チェックイン日付の当月用
        const endOfMonth = selectDay.clone().endOf('month');
        const dayCount = endOfMonth.diff(selectDay, 'days');
        for (let i = 0; i <= dayCount; i++) {
          const day = selectDay.clone().add(i, 'days').format(this.dateFormat);
          selectedDayByMonth.push(day);
        }
      } else if (funcType === "1") {
        // チェックアウト日付の当月用
        const startOfMonth = selectDay.clone().startOf('month');
        const dayCount = selectDay.diff(startOfMonth, 'days');
        for (let i = 0; i <= dayCount; i++) {
          const day = startOfMonth.clone().add(i, 'days').format(this.dateFormat);
          selectedDayByMonth.push(day);
        }
      }
      return selectedDayByMonth;
    },

    handleOk() {
      if( !this.stayDay ) return ;

      const stayDays = this.isDateSpecified ? this.stayDay : null
      // 日付設定なしでURLに日付ありの場合は日付解除なので泊数リセット、日付設定なし、URLに日付なしの場合は泊数をクエリのデータにする、それ以外はモーダル設定値に
      console.log("query date", this.$route.query.stayNights)
      console.log("this nights", this.stayNights)
      console.log("specified", (!this.isDateSpecified))
      // クエリから数値を取得するときはNumberに変換する
      const stayNights = (!this.isDateSpecified && this.$route.query.checkInDate) ? 1 : (!this.isDateSpecified) ? Number(this.$route.query.stayNights) :this.stayNights
      this.stayNightsSP = stayNights

      this.$emit('ok', {
        stayDays,
        stayNights,
        isDeleteDate: !this.isDateSpecified,
        searchResult: this.searchResult
      })
    },

    handleCancel() {
      this.$emit('cancel')
    },
    /**
     * 日付を指定するチェックボックスON／OFF処理
     */
    toggleCheckbox() {
      // OFF→ON： 押されたときにfalseだったら。宿泊開始日を本日＋１日（翌日）にセット
      if (!this.isDateSpecified) {
        this.stayDay = moment().add(1, 'd')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
/deep/ .popover-contain {
  width: 450px;
}

.cal-days {
  margin-bottom: 0;
}

.content {
  &__box {
    display: flex;
    column-gap: 40px;
    align-items: center;
    margin-bottom: 25px;
  }
  &__input {
    input[type="checkbox"] {
      display: none;
      &:checked + .content__label::before {
        opacity: 1;
      }
    }
  }
  &__label {
    position: relative;
    padding-left: 35px;
    font-size: 15px;
    font-weight: bold;
    color: black;
    &::before,
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
    }
    &::before {
      left: 8px;
      margin-top: -9px;
      width: 9px;
      height: 14px;
      border-right: 3px solid #E60021;
      border-bottom: 3px solid #E60021;
      transform: rotate(45deg);
      opacity: 0;
    }
    &::after {
      left: 0;
      margin-top: -12px;
      width: 24px;
      height: 24px;
      border: 1px solid #CACCCF;
      border-radius: 4px;
    }
  }
}

::v-deep  .ant-modal-body {
  @include mq() {
    padding: 24px 20px;
  }
}

@media (max-width: $contentWidthS) {
  .content {
    &__box {
      column-gap: 15px;
    }
    &__label {
      display: block;
      padding-left: 25px;
      font-size: 13px;
      margin-top: -2px;
      &::before {
        width: 7px;
        height: 12px;
        left: 7px;
        margin-top: -5px;
      }
      &::after {
        width: 20px;
        height: 20px;
        margin-top: -8px;
      }
    }
  }
}

</style>
